<template>
  <custom-popup
    v-model="dialog"
    :cons="popupCons"
    max-width="850"
    hide-confirm
    persistent
    @close="closeModal"
    @reload="fetch"
  >
    <custom-tabs
      v-if="dialog"
      v-model="currentTab"
      :tab-items="tabItems"
      :window-items="[0, 1, 2]"
      grow
      class="mx-2 my-4"
    >
      <template #item="{ item }">
        <!-- تب ۱: اطلاعات پایه -->
        <div v-show="item === 0" class="pt-4">
          <product-form-tab
            :product-id="localProductId"
            @saved="onProductSaved"
            @close="closeModal"
          />
        </div>

        <!-- تب ۲: قیمت‌گذاری و ارسال -->
        <div v-show="item === 1" class="pt-4">
          <SmartPricingModal
            ref="smartPricingModal"
            :key="localProductId"
            :product_id="localProductId"
            @saved="onPricingSaved"
            @close="closeModal"
            :is-edit="isInitialEdit"
          />
        </div>

        <!-- تب ۳: تخفیف فروش عمده -->
        <div v-show="item === 2" class="pt-4">
          <BulkDiscountTab
            ref="BulkDiscountTab"
            :key="localProductId"
            :product-id="localProductId"
            @saved="onBulkDiscountSaved"
            @close="closeModal"
          />
        </div>
      </template>
    </custom-tabs>
  </custom-popup>
</template>

<script>
import ProductFormTab from "./productformtab.vue";
import SmartPricingModal from "../product/SmartPricingModal.vue";
import BulkDiscountTab from "../SettingsPage/BulkDiscountTab.vue";

export default {
  name: "ProductFormModal",
  components: {
    ProductFormTab,
    SmartPricingModal,
    BulkDiscountTab
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    selectedProduct: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      currentTab: 0,
      localProductId: null,
      savedProductTitle: "",
      isInitialEdit: false,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    popupCons() {
      const titleText =
        this.savedProductTitle ||
        (this.selectedProduct && this.selectedProduct.title) ||
        "";
      return {
        title: this.isInitialEdit
          ? `ویرایش محصول: ${titleText}`
          : "تعریف محصول جدید",
        icon: this.isInitialEdit
          ? "package-variant-closed-edit"
          : "package-variant-closed-plus",
      };
    },
    tabItems() {
      return [
        { text: "اطلاعات پایه محصول", icon: "package", disabled: false },
        { text: "قیمت‌گذاری و ارسال", icon: "cash-refund", disabled: !this.localProductId },
        { text: "تخفیف فروش عمده", icon: "cart-percent", disabled: false }
      ];
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.isInitialEdit = !!(this.selectedProduct && this.selectedProduct.id);
          this.localProductId = this.selectedProduct ? this.selectedProduct.id : null;
          this.savedProductTitle = this.selectedProduct ? this.selectedProduct.title : "";
          this.currentTab = 0;
        }
      },
    },
  },
  methods: {
    fetch() {
      this.$emit("refresh");
    },
    onProductSaved(data) {
      let resolvedId = null;
      if (typeof data === "object" && data !== null) {
        resolvedId = data.id || data.product_id;
        if (data.title) this.savedProductTitle = data.title;
      } else {
        resolvedId = data;
      }

      if (resolvedId) {
        this.localProductId = resolvedId;
      }

      this.$emit("refresh");

      this.$nextTick(() => {
        setTimeout(() => {
          this.currentTab = 1;
        }, 150);
      });
    },
    onPricingSaved() {
      this.$emit("refresh");
      this.closeModal();
    },
    onBulkDiscountSaved() {
      this.$emit("refresh");
      this.closeModal();
    },
    closeModal() {
      this.dialog = false;
      this.currentTab = 0;
      this.localProductId = null;
      this.savedProductTitle = "";
      this.isInitialEdit = false;
    },
  },
};
</script>
